import { sendToFlutter } from '@/bridge.js';

/**
 * Forwards child-card events to Flutter as `navigate`.
 * The chat window close button sends `close` itself.
 */
export const flutterBridgeMixin = {
    created() {
        if (this.__flutterEmitWrapped || typeof this.$emit !== 'function') return;
        const original = this.$emit.bind(this);
        const wrapped = (event, payload) => {
            try {
                sendToFlutter('navigate', {
                    event: String(event || ''),
                    payload: payload === undefined ? null : payload,
                    source: this.$options.name || 'chatbot'
                });
            } catch (err) {
                sendToFlutter('error', {
                    message: err && err.message ? err.message : 'Chatbot event failed',
                    source: this.$options.name || 'chatbot'
                });
            }
            return original(event, payload);
        };
        try {
            this.$emit = wrapped;
            this.__flutterEmitWrapped = true;
        } catch (err) {
            // Some Vue builds expose $emit as read-only. The card still works.
        }
    }
};
